(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-data"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sanitasShipping) return;
    window.__sanitasShipping = true;

    let cachedConfig = null;
    function loadConfig() {
      if (cachedConfig) return cachedConfig;
      const el = document.getElementById('sanitas-shipping-data');
      if (!el) return null;
      try { cachedConfig = JSON.parse(el.textContent); return cachedConfig; }
      catch (e) { return null; }
    }

    function fmtMoney(cents, currency) {
      const value = (cents || 0) / 100;
      const locale = document.documentElement.lang || 'de-DE';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) { return value.toFixed(2).replace('.', ',') + ' €'; }
    }

    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.context = this.dataset.context || 'drawer';
        this.config = loadConfig();
        if (!this.config) return;
        this.rate = this.config.rates[this.config.country_code] || this.config.rates.DEFAULT;
        if (!this.rate) return;

        this._onUpdate = this._onUpdate.bind(this);
        document.addEventListener('cart:update', this._onUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this._onUpdate);
      }

      async _onUpdate(event) {
        let total = event && event.detail && event.detail.resource && event.detail.resource.total_price;
        if (total == null) {
          try {
            const r = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
            total = (await r.json()).total_price;
          } catch (e) { return; }
        }
        const self = this;
        requestAnimationFrame(function () { self._update(total); });
      }

      _update(total) {
        if (!this.config || !this.rate) return;
        const cfg = this.config;
        const rate = this.rate;
        const remaining = Math.max(0, cfg.threshold_cents - total);
        const pct = cfg.threshold_cents > 0 ? Math.min(100, (total / cfg.threshold_cents) * 100) : 0;
        const unlocked = rate.free_eligible && total >= cfg.threshold_cents;
        const remainingText = fmtMoney(remaining, cfg.currency_code);

        this.classList.toggle('is-unlocked', unlocked);

        const fill = this.querySelector('[data-fsb-fill]');
        if (fill) fill.style.width = pct + '%';

        const track = this.querySelector('.fsb__track');
        if (track) {
          track.setAttribute('aria-valuenow', String(Math.round(pct)));
        }

        const amountEls = this.querySelectorAll('[data-fs-amount]');
        for (let i = 0; i < amountEls.length; i++) {
          amountEls[i].textContent = remainingText;
        }

        const msgCard = this.querySelector('[data-fsb-msg-card]');
        if (msgCard) msgCard.hidden = unlocked;

        const freeEl = this.querySelector('[data-fsb-free]');
        if (freeEl) freeEl.hidden = !unlocked;
      }
    }

    class FreeShippingToast extends HTMLElement {
      connectedCallback() {
        this.config = loadConfig();
        if (!this.config) return;
        this.rate = this.config.rates[this.config.country_code] || this.config.rates.DEFAULT;
        if (!this.rate || !this.rate.free_eligible) return;

        this._onUpdate = this._onUpdate.bind(this);
        document.addEventListener('cart:update', this._onUpdate);
        this._hideTimer = null;
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this._onUpdate);
        clearTimeout(this._hideTimer);
      }

      async _onUpdate(event) {
        let total = event && event.detail && event.detail.resource && event.detail.resource.total_price;
        const itemCount = event && event.detail && event.detail.resource && event.detail.resource.item_count;
        if (total == null) {
          try {
            const r = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
            const data = await r.json();
            total = data.total_price;
          } catch (e) { return; }
        }
        if (itemCount === 0) { this._hide(); return; }
        this._update(total);
        this._showVisible();
      }

      _update(total) {
        if (!this.config) return;
        const cfg = this.config;
        const remaining = Math.max(0, cfg.threshold_cents - total);
        const unlocked = total >= cfg.threshold_cents;
        const remainingText = fmtMoney(remaining, cfg.currency_code);

        const amountEls = this.querySelectorAll('[data-fs-amount]');
        for (let i = 0; i < amountEls.length; i++) {
          amountEls[i].textContent = remainingText;
        }

        const lockedText = this.querySelector('[data-fst-locked-text]');
        if (lockedText) lockedText.hidden = unlocked;
        const unlockedText = this.querySelector('[data-fst-unlocked-text]');
        if (unlockedText) unlockedText.hidden = !unlocked;
      }

      _showVisible() {
        this.setAttribute('data-visible', 'true');
        clearTimeout(this._hideTimer);
        const self = this;
        this._hideTimer = setTimeout(function () { self._hide(); }, 3500);
      }

      _hide() { this.removeAttribute('data-visible'); }
    }

    customElements.define('free-shipping-bar', FreeShippingBar);
    customElements.define('free-shipping-toast', FreeShippingToast);
  })();
  } catch(e) { console.error(e); }
})();

})();
